import { useSearchParams } from 'react-router'

import { resolveWorkflowIdParam } from '~/models/workflowIdParam'

/**
 * URL クエリパラメータ `?workflowId=` (旧 `?caseId=` も受け付ける) の業務ワークフローケース ID
 * (UUID。 人が読む業務 ID のワークフローID ではない)。 無ければ `undefined`。
 * ケースの取得は伴わない。 ケース本体・read-only 判定が要る画面は `useCurrentWorkflowCase` を使う。
 */
export function useWorkflowCaseIdParam(): string | undefined {
  const [searchParams] = useSearchParams()
  return resolveWorkflowIdParam(searchParams)
}
